
import {getProp} from 'custom/object-helper'
import {OPTIONS_REDUCER} from './options/reducer'
import {SET_EXAM_DATA} from 'redux/reducers/exam/action-types'


// Note: state should always be initialized at this point (via QUESTION_REDUCER)
const CHECKS_QUESTION_REDUCER = (state, action) =>
{
	switch (action.type)
	{
		case SET_EXAM_DATA:
			state = state.set('minOptions', action.data['@Minimum']);
			state = state.set('maxOptions', action.data['@Maximum']);
			const optionsData = getProp(action, 'data.OPTIONS.OPTION');
			const optionsAction = {...action, data: optionsData};
			state = state.set('maxOptions', action.data['@Maximum']);
			return state.set('options', OPTIONS_REDUCER(undefined, optionsAction));
		default:
			return state;
	}
}

export {CHECKS_QUESTION_REDUCER}